module.exports = __webpack_public_path__ + "static/media/logo.713f9d52.png";